
const initialState = {
    loading: false,
    loaded: false,
    data: null,
    error: false
};

function createLoaderReducer(actionType) {
    return (state = initialState, action) => {
        switch (action.type) {
            case actionType.DEFAULT:
                return {
                    ...state,
                    data: null,
                    error: false,
                    loading: true,
                    loaded: false
                };

            case actionType.CLEAR:
                return {
                    ...initialState
                };

            case actionType.SUCCESS:
                return {
                    ...state,
                    data: action.data,
                    error: false,
                    loading: false,
                    loaded: true
                };

            case actionType.FAILED:
                return {
                    ...state,
                    error: true,
                    loading: false
                };

            default:
                return state
        }
    }
}

function getIsLoading(state) {
    return state.loading;
}

function getIsLoaded(state) {
    return (
        state.loaded &&
        !state.loading
    );
}

export {
    initialState,
    createLoaderReducer,
    getIsLoaded,
    getIsLoading
};
